import { GetNameDefForObj } from "./GetNameDefForObj";

export function compareorphans(a, b) {
  var fieldDef = GetNameDefForObj(a);
  if (fieldDef == null) return 0;

  var av = a.GetFieldValue(fieldDef);
  var bv = b.GetFieldValue(fieldDef);

  if (av == null) av = "";
  if (bv == null) bv = "";

  av = av.toString().toLowerCase();
  bv = bv.toString().toLowerCase();

  var namesA = av.split(" ");
  var lastNameA = namesA[namesA.length - 1];
  var namesB = bv.split(" ");
  var lastNameB = namesB[namesB.length - 1];

  if (lastNameA == lastNameB) {
    var firstNameA = namesA[0];
    var firstNameB = namesB[0];

    if (firstNameA == firstNameB) return 0;
    else {
      if (firstNameA < firstNameB) return -1;
      else return 1;
    }
  } else {
    if (lastNameA < lastNameB) return -1;
    else return 1;
  }
}
